export default "__VITE_ASSET__DqexZrP8__"